/**
 * Convert a `Headers` object into a plain object.
 */
export const intoObject = (headers: Headers): Record<string, string> => {
  const result: Record<string, string> = {};
  // `Object.fromEntries(response.headers.entries())` is preferrable
  // https://developer.mozilla.org/en-US/docs/Web/API/Headers/entries
  // eslint-disable-next-line unicorn/no-array-for-each -- `.entries` is not always available in older node versions
  headers.forEach((value, key) => {
    result[key] = value;
  });
  return result;
};

/**
 * Wait for a given amount of time with optional abort signal.
 */
export const wait = (ms: number, signal?: AbortSignal | null): Promise<void> =>
  new Promise((resolve, reject) => {
    if (signal?.aborted) reject(signal.reason);

    const timeout = setTimeout(resolve, ms);

    signal?.addEventListener(
      'abort',
      () => {
        clearTimeout(timeout);
        reject(signal.reason);
      },
      { once: true },
    );
  });

export const anySignal = (signals: Iterable<AbortSignal>): AbortSignal => {
  const controller = new AbortController();

  for (const signal of signals) {
    if (signal.aborted) {
      controller.abort(signal.reason);
      return signal;
    }

    signal.addEventListener('abort', () => controller.abort(signal.reason), {
      signal: controller.signal,
    });
  }

  return controller.signal;
};

export const isErrorLike = (object: unknown): object is Error =>
  object instanceof Error ||
  object?.constructor?.name === 'Error' ||
  object?.constructor?.name === 'DOMException';
